var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8706 10.9539C31.7162 5.09706 26.5724 0.700195 20.393 0.700195C15.4869 0.700195 11.2258 3.48431 9.10381 7.55862C3.99394 8.10186 0.0214844 12.4308 0.0214844 17.6765C0.0214844 23.2957 4.58811 27.8623 10.2073 27.8623H32.2765C36.9619 27.8623 40.7646 24.0596 40.7646 19.3741C40.7646 14.8924 37.2845 11.2595 32.8706 10.9539ZM23.7883 15.9789V22.7694H16.9978V15.9789H11.9049L20.393 7.49072L28.8812 15.9789H23.7883Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloudUpload.4a9a4018846a9f27cd7df154305db63c.svg";
export { ForwardRef as ReactComponent };